import { render, staticRenderFns } from "./createHoliday.vue?vue&type=template&id=b6c3405e&"
import script from "./createHoliday.vue?vue&type=script&lang=js&"
export * from "./createHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports